import { Component } from '../../../libs/gin-tonic/helpers/compiler';

@Component({ className: 'js-nav-toggler' })
export class NavTogglerComponent {
	private hamburger: HTMLElement;
	private search: HTMLElement;
	private searchInput: HTMLInputElement;

	constructor(private element: HTMLElement) {
		this.hamburger = document.querySelector('.js-nav-toggler-hamburger') as HTMLElement;
		this.search = document.querySelector('.js-nav-toggler-search') as HTMLElement;
		this.searchInput = document.querySelector('.js-nav-toggler-search-input') as HTMLInputElement;

		this.initHamburgerToggleLogic();
		this.initSearchToggleLogic();
	}

	initHamburgerToggleLogic() {
		if (!this.hamburger) return;

		document.addEventListener('keydown', e => {
			if (
				e.key == 'Escape' &&
				(this.hamburger.getAttribute('aria-expanded')?.toLowerCase() == 'true' || this.hamburger.classList.contains('is-active'))
			) {
				this.hamburger.click();
				this.hamburger.focus();
			}
		});
	}

	initSearchToggleLogic() {
		if (!this.search) return;
		document.addEventListener('keydown', e => {
			if (e.key == 'Escape' && (this.search.getAttribute('aria-expanded')?.toLowerCase() == 'true' || this.search.classList.contains('is-active'))) {
				this.search.click();
				this.search.focus();
			}
		});

		const observer = new MutationObserver(mutations => {
			mutations.forEach(mutation => {
				if (mutation.type === 'attributes') {
					if (mutation.attributeName === 'class' && this.search.classList.contains('is-active')) {
						this.searchInput.focus();
						this.searchInput.select();
					} else {
						this.searchInput.blur();
					}
				}
			});
		});

		const config = {
			attributes: true,
			attributeFilter: ['class']
		};

		observer.observe(this.search, config);
	}
}
